var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as __au2ViewDef from './sub-grid-calc.html';
import { customElement, valueConverter } from '@aurelia/runtime';
import { MemoriaStoneModel } from '../models/memoria-stone-model';
// https://stackoverflow.com/a/22780569
function jsonp(url, callback) {
    const callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());
    const script = document.createElement('script');
    window[callbackName] = function (data) {
        delete window[callbackName];
        document.body.removeChild(script);
        callback(data);
    };
    script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + callbackName;
    document.body.appendChild(script);
}
let KeysValueConverter = class KeysValueConverter {
    toView(obj) {
        return Reflect.ownKeys(obj).filter(x => x[0] != '$');
    }
};
KeysValueConverter = __decorate([
    valueConverter('keys')
], KeysValueConverter);
export { KeysValueConverter };
let SubGridCalc = class SubGridCalc {
    constructor() {
        this.entered = false;
    }
    selectStone(stone) {
        this.selectedStone = stone;
        console.log(stone);
        console.log(typeof stone.stats);
    }
    get HP() {
        return Math.round(this.selectedStone.max().hp * 0.10 * 9);
    }
    get ATK() {
        return Math.round(this.selectedStone.max().atk * 0.10 * 9);
    }
    get DEF() {
        return Math.round(this.selectedStone.max().def * 0.10 * 9);
    }
    get HPA() {
        return Math.round(this.selectedStone.adorned().hp * 0.10 * 9);
    }
    get ATKA() {
        return Math.round(this.selectedStone.adorned().atk * 0.10 * 9);
    }
    get DEFA() {
        return Math.round(this.selectedStone.adorned().def * 0.10 * 9);
    }
    get HPE() {
        return Math.round(this.selectedStone.max().hp * 0.15 * 9);
    }
    get ATKE() {
        return Math.round(this.selectedStone.max().atk * 0.15 * 9);
    }
    get DEFE() {
        return Math.round(this.selectedStone.max().def * 0.15 * 9);
    }
    get HPEA() {
        return Math.round(this.selectedStone.adorned().hp * 0.15 * 9);
    }
    get ATKEA() {
        return Math.round(this.selectedStone.adorned().atk * 0.15 * 9);
    }
    get DEFEA() {
        return Math.round(this.selectedStone.adorned().def * 0.15 * 9);
    }
    enter() {
        jsonp('https://talesofcrestoria.fandom.com/api.php?format=json&action=parse&pageid=5065', (data) => {
            const parser = new DOMParser();
            const html = parser.parseFromString(data.parse.text['*'], 'text/html');
            const blocks = [].slice.call(html.querySelectorAll('code'));
            const dataArray = blocks.map(stoneBlock => {
                let stoneString = stoneBlock.innerText.replace('\n', ''); //.replace(/[^((["'])(?:(?=(\\?))\2.)*?\1){},]*/g, '');
                if (stoneString[stoneString.length - 1] === ',')
                    stoneString = stoneString.substr(0, stoneString.length - 1);
                return JSON.parse(stoneString);
            });
            this.stones = MemoriaStoneModel.fromDataArray(dataArray);
            this.selectedStone = this.stones[0];
        });
    }
};
SubGridCalc = __decorate([
    customElement(Object.assign(Object.assign({}, __au2ViewDef), { dependencies: [...__au2ViewDef.dependencies, KeysValueConverter] }))
], SubGridCalc);
export { SubGridCalc };
